import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const VERSES = [
  { ref: "Matthew 28:19", text: "Go therefore and make disciples of all nations, baptizing them in the name of the Father and of the Son and of the Holy Spirit." },
  { ref: "John 8:12", text: "I am the light of the world. Whoever follows me will not walk in darkness, but will have the light of life." },
  { ref: "Acts 1:8", text: "And you will be my witnesses in Jerusalem and in all Judea and Samaria, and to the end of the earth." },
  { ref: "Romans 10:15", text: "How beautiful are the feet of those who preach the good news!" },
  { ref: "Psalm 119:105", text: "Your word is a lamp to my feet and a light to my path." },
  { ref: "Matthew 5:16", text: "Let your light shine before others, so that they may see your good works and give glory to your Father in heaven." },
];

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
